import { setGridTableDefaults } from "@homebound/beam";
import { useEffect } from "react";
import { useCurrentInternalUserQuery } from "src/queries/user.generated";
import { setAnalyticsUser } from "src/utils/analytics";
import { showIdColumn } from "src/utils/idColumn";

/** Analytics + grid defaults used by data-router `AuthenticatedShell`. */
export function useLoggedInAppSetup() {
  const { data } = useCurrentInternalUserQuery();
  const { id, name, email } = data?.currentInternalUser || {};

  // Apply grid table defaults for empty cells
  setGridTableDefaults({ stickyHeader: true, style: { allWhite: true } });

  useEffect(() => {
    setAnalyticsUser({ id, name, email });
    // Always show the debugging `ID` column
    if (email?.includes("shaberman")) {
      showIdColumn();
    }
  }, [id, name, email]);
}
